import React from "react";
import i18n from "../../i18n";

import {
  Button,
  Menu,
  MenuItem,
  MenuDivider,
  Spinner,
} from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";

import {
  authenticatedGetFetch,
  authenticatedGetFetchWithoutLoginRedirection,
} from "../../utils/AuthenticatedFetch";

export function deviceLookup(force_update = false) {
  return new Promise((res, rej) => {
    if (localStorage.getItem("deviceLookup") == null || force_update) {
      authenticatedGetFetchWithoutLoginRedirection(
        "/devices",
        (response) => {
          const lookup = {};
          for (const device of response) {
            lookup[device.id] = device.id + " - " + device.name;
            lookup[device.park.server.id + "_" + device.id] = device.id + " - " + device.name;
          }
          localStorage.setItem("deviceLookup", JSON.stringify(lookup));
          res(lookup);
        },
        null,
        () => {
          res({});
        }
      );
    } else res(JSON.parse(localStorage.getItem("deviceLookup")));
  });
}

export default class EquipmentListSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      open: false,
      equipments: [],
    };
  }

  componentDidMount() {
    authenticatedGetFetch(
      "/devices" +
        (this.props.type !== undefined
          ? "?" +
            new URLSearchParams({
              type: this.props.type,
              srvfilter: this.props.srv,
            })
          : ""),
      (response) => this.setState({ loaded: true, equipments: response })
    );
  }

  getNotSelectedEquipments() {
    if (this.props.valueSelected?.findIndex !== undefined)
      return this.state.equipments.filter((el) => {
        return this.props.valueSelected?.findIndex((vs) => el.id === vs.id) < 0;
      });
    else return this.state.equipments;
  }

  render() {
    if (!this.state.loaded) {
      return <Spinner />;
    } else {
      if (this.state.open)
        return (
          <Select
            items={this.getNotSelectedEquipments()}
            itemRenderer={(item, { select, modifiers }) => {
              return (
                <MenuItem
                  key={
                    item.id +
                    "_" +
                    item?.park?.id +
                    "_" +
                    item?.park?.server?.id
                  }
                  label={`(parc: ${item?.park?.name}, srv: ${item?.park?.server?.name})`}
                  text={`${item.name}`}
                  onClick={() => {
                    this.props.onSelect(item.id, item);
                    this.setState({ open: false });
                  }}
                />
              );
            }}
            itemListRenderer={({
              items,
              itemsParentRef,
              query,
              renderItem,
            }) => {
              const renderedItems = items
                .map(renderItem)
                .filter((item) =>
                  (item.props.text + item.props.label)
                    .toUpperCase()
                    .includes(query.toUpperCase())
                );
              return (
                <Menu ulRef={itemsParentRef}>
                  <MenuItem disabled={true} />
                  {renderedItems}
                </Menu>
              );
            }}
          >
            <Button
              text={i18n.t("select an equipment to add")}
              rightIcon="double-caret-vertical"
            />
          </Select>
        );
      else
        return (
          <Button
            icon="add"
            text={this.props.label || ""}
            onClick={() => this.setState({ open: true })}
          />
        );
    }
  }
}

export class EquipmentSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      equipments: [],
      selection: props.selection !== undefined ? props.selection : undefined,
    };
  }

  componentDidMount() {
    if (this.props.filter === "exception")
      authenticatedGetFetch("/equipments/exceptiontargets", (response) =>
        this.setState({ equipments: response })
      );
    else
      authenticatedGetFetch("/devices", (response) =>
        this.setState({ equipments: response })
      );
  }

  render() {
    return (
      <div>
        <Select
          items={this.state.equipments}
          itemRenderer={(item, { select, modifiers }) => {
            return (
              <MenuItem
                key={
                  "ID:" +
                  item.id +
                  "/Park:" +
                  item.parkId +
                  "/Server:" +
                  item.park.serverId
                }
                label={item.id}
                text={
                  item.name === null
                    ? item.type + " " + item.id
                    : item.type + " " + item.id + " (" + item.name + ")"
                }
                onClick={() => {
                  this.props.onSelect(
                    item.id,
                    item.park.id,
                    item.serverId,
                    item.pk
                  );
                  this.setState({
                    open: false,
                    selection:
                      item.name === null
                        ? item.type + " " + item.id
                        : item.type + " " + item.id + " (" + item.name + ")",
                  });
                }}
              />
            );
          }}
          itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
            const newArray = [];
            for (const i in items) {
              if (!newArray.find((item) => item.Park === items[i].park.name)) {
                newArray.push({
                  Park: items[i].park.name,
                  equipments: [renderItem(items[i])],
                });
              } else {
                newArray
                  .find((item) => item.Park === items[i].park.name)
                  .equipments.push(renderItem(items[i]));
              }
            }

            const renderedItems = [];
            for (const i in newArray) {
              renderedItems.push(<MenuDivider title={newArray[i].Park} />);
              renderedItems.push(
                newArray[i].equipments.filter((item) =>
                  item.props.text.toUpperCase().includes(query.toUpperCase())
                )
              );
            }

            // const renderedItems = items
            //   .map(renderItem)
            //   .filter(
            //     (item) =>
            //       item != null &&
            //       item.props.text != null &&
            //       item.props.text.toUpperCase().includes(query.toUpperCase())
            //   );
            return (
              <Menu ulRef={itemsParentRef}>
                <MenuItem disabled={true} />
                {renderedItems}
              </Menu>
            );
          }}
        >
          <Button
            text={
              this.state.selection !== undefined
                ? this.state.selection
                : i18n.t("select an equipment")
            }
            rightIcon="double-caret-vertical"
          />
        </Select>
      </div>
    );
  }
}
